import { dispatchAction } from '@ardoq/rxbeach';
import { newItemHovered } from '../actions';
import { SelectItemContainer } from '../components/Atoms';

export const getOnMouseOverHandler = () => {
  const lastHighlightedRef: { current: Element | null } = { current: null };
  return (event: React.MouseEvent) => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }
    const highlightedOption = event.target.closest(
      `${String(SelectItemContainer)}`
    );
    if (highlightedOption === lastHighlightedRef.current) {
      return;
    }
    lastHighlightedRef.current = highlightedOption;
    if (highlightedOption) {
      const nodeId = highlightedOption.getAttribute('data-id');
      if (nodeId) {
        dispatchAction(newItemHovered({ nodeId }));
      }
    }
  };
};
